import React from "react";
import { Button, Tooltip, type ButtonProps } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import {
  type CalendarEvent,
  getGoogleCalendarUrl,
} from "../types/AddtoCalendarutils";

interface AddToCalendarButtonProps {
  event: CalendarEvent;
  variant?: ButtonProps["variant"];
  color?: ButtonProps["color"];
  size?: ButtonProps["size"];
  label?: string;
  sx?: ButtonProps["sx"];
}

export const AddToCalendarButton: React.FC<AddToCalendarButtonProps> = ({
  event,
  variant = "outlined",
  color = "primary",
  size = "medium",
  label = "Add to Calendar",
  sx,
}) => {
  const handleClick = () => {
    window.open(getGoogleCalendarUrl(event), "_blank", "noopener,noreferrer");
  };

  return (
    <Tooltip title="Add to Google Calendar" placement="top" arrow>
      <Button
        variant={variant}
        color={color}
        size={size}
        onClick={handleClick}
        startIcon={<CalendarMonthIcon />}
        sx={sx}
      >
        {label}
      </Button>
    </Tooltip>
  );
};

export default AddToCalendarButton;
